const axios = require('axios');

export default async function setLinkPago(form) {
    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage._session_token}`
            }
        }
        const { data } = await axios.post(`${process.env.api}/pago`, form, config)
        return { data, error: null };
    } catch (error) {
        return { data: null, error: error };
    }
}